<template>
  <TheBaseGrid :showEditor="false" editorHeight="230px" @next="checkInput">

    <template slot="intro">
      <h2>Level 2 er klaret 👏🏽</h2>
      <p>
        Damn du er sej:-)
      </p>
    </template>

    <template slot="cssInput">
    </template>

    <template slot="output">
      <h1
      :style="showStyle">Hello world</h1>
    </template>

  </TheBaseGrid>
</template>

<script>
import { mapState } from 'vuex';
import TheBaseGrid from '@/components/TheBaseGrid.vue'
export default {
  name: 'episode6',
  components: {
    TheBaseGrid
  },
  computed: {
    ...mapState([
      'season'
    ]),
    showStyle (){
      let f = this.season[0].episode[this.$route.params.episodeNumber-6].cssInput
      let e = this.season[0].episode[this.$route.params.episodeNumber-5].cssInput
      let d = this.season[0].episode[this.$route.params.episodeNumber-4].cssInput
      let c = this.season[0].episode[this.$route.params.episodeNumber-3].cssInput
      let b = this.season[0].episode[this.$route.params.episodeNumber-2].cssInput
      let a = this.season[0].episode[this.$route.params.episodeNumber-1].cssInput
      return f+e+d+c+b+a
    }
  },
  methods: {
    checkInput(){
      this.$router.push({ path: '/season/2/episode/0' })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
